import {
	JobFacet,
	JobFilterType,
	JobSelectedFilter,
	PublishJobFilterItem
} from 'containers/Types';
import React, { useCallback, useEffect, useState } from 'react';
import { JobFilterDynamicData } from './JobFilterDynamicData';
import { useSearchParams } from 'react-router-dom';

function JobDynamicFilter({
	list,
	filters,
	visibleItems,
	setPageNumber
}: {
	list?: JobFacet[];
	filters?: JobSelectedFilter;
	visibleItems?: number;
	setPageNumber?: any;
}) {
	const [searchParams, setSearchParams] = useSearchParams();
	const query = Object.fromEntries(searchParams.entries());
	const [filterBox, setFilterBox] = useState<any>([]);
	const [facetList, setFacetList] = useState<JobFacet[]>([]);

	const groupJobTagsByCategory = (jobTagsFacet: JobFacet | undefined) => {
		if (!jobTagsFacet) return;
		const grouped = jobTagsFacet.items.reduce(
			(acc: Record<string, any>, item) => {
				const [, category] = item.value.split('|');
				if (!acc[category]) {
					acc[category] = {
						facet: `${category}`,
						items: []
					};
				}
				acc[category].items.push(item);
				return acc;
			},
			{}
		);

		return Object.values(grouped);
	};

	useEffect(() => {
		if (!list || list.length === 0) return;
		const jobTagsFacet = groupJobTagsByCategory(
			list.find((item: JobFacet) => item.facet === 'JobTags/Title')
		)?.map(
			({
				facet,
				items
			}: {
				facet: string;
				items: { value: string }[];
			}) => ({
				facet,
				items: items.map(({ value, ...rest }: { value: string }) => ({
					...rest,
					value: value
						.split('|')
						.filter((_: string, index: number) => index !== 1)
						.join('|')
				}))
			})
		);

		const updatedFilterBox = [
			...(jobTagsFacet ? jobTagsFacet.map((item) => item.facet) : [])
		];

		const updatedFacetList = [...(jobTagsFacet || [])];

		setFilterBox(updatedFilterBox);
		setFacetList(updatedFacetList as any);
	}, [list]);

	const checkSelected = useCallback(
		(value: string) => {
			return (filters?.['jobTags'] as string[])?.includes(value) ?? false;
		},
		[filters]
	);

	const getUpdatedList = useCallback(
		(filter: JobFilterType) => {
			const items = facetList?.filter((item) => item.facet === filter)[0];
			items?.items?.forEach((item) => {
				item['isChecked'] = checkSelected(item.value.split('|')[0]);
			});
			return items?.items;
		},
		[facetList, checkSelected]
	);

	const handleApplyFilter = (selected_filters: PublishJobFilterItem[]) => {
		const filter_values = selected_filters
			.map((filter) => filter.value.split('|')[0])
			.join(',');

		const existingJobTags = query['JobTags']
			? typeof query['JobTags'] === 'string'
				? query['JobTags'].split(',')
				: []
			: [];
		const newJobTags = filter_values ? filter_values.split(',') : [];
		const combinedJobTags = Array.from(
			new Set([...existingJobTags, ...newJobTags])
		).join(',');
		if (combinedJobTags) {
			setSearchParams({
				page: '1',
				['JobTags']: combinedJobTags
			});
			setPageNumber && setPageNumber(1);
		}
	};
	return (
		<>
			{filterBox?.map((filter: any, idx: number) => (
				<JobFilterDynamicData
					key={`${filter}_${idx}`}
					type={filter}
					list={getUpdatedList(filter) as PublishJobFilterItem[]}
					onApplyFilter={(selected) => handleApplyFilter(selected)}
					visibleItems={visibleItems}
				/>
			))}
		</>
	);
}

export default JobDynamicFilter;